import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  "deleteConfirmation": {
    id: "pages.support.deleteConfirmation",
    defaultMessage: "This action will delete the ticket and all associated data.",
    description: "Confirmation message when deleting a ticket"
  },
  "cancelButton": {
    id: "pages.support.cancelButton",
    defaultMessage: "Cancel",
    description: "Text for cancel button"
  },
  "deleteButton": {
    id: "pages.support.deleteButton",
    defaultMessage: "Delete",
    description: "Text for delete button"
  }
});

export default messages; 